import moment from 'moment';

export const formatNumber = (number: number, minimumFractionDigits: number, numberFormatter?: string): string =>
  number.toLocaleString(numberFormatter || 'de-CH', {
    minimumFractionDigits,
  });

export const formatDate = (date: Date, dateFormat?: string): string => moment(date).format(dateFormat);

export const formatTransactionDate = (date: Date, dateFormat?: string): string => moment.utc(date).format(dateFormat);
